import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { rhythm, media, color } from '../utils/typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import classnames from 'classnames'
import { withTranslation } from 'react-i18next'

import Link from './link'
import Image from './image'
import LanguageSwitcher from './language-switcher'

export default styled(withTranslation()(({ className, t, root }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo-black.png" }) {
        childImageSharp {
          fixed(width: 50) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <footer className={classnames({root, [className]: true})}>
      <Image className='logo' fixed={data.logo.childImageSharp.fixed} />
      <h1 className='brand'>
        <span>{t('ipac.name')}</span>
        <span>對華政策跨國議會聯盟</span>
        <span>对华政策跨国议会联盟</span>
        <span>対中政策に関する列国議会連盟</span>
      </h1>

      <ul className='inline-list links'>
        <li><Link to='/about'>{t('about.title')}</Link></li>
        <li><Link to='/statement'>{t('statement.title')}</Link></li>
        <li><Link to='/campaigns'>{t('campaigns.title')}</Link></li>
        <li><Link to='/team'>{t('members.title')}</Link></li>
        {/*<li><Link to='/resources'>{t('resources.title')}</Link></li>*/}
        <li><Link to='/news'>{t('articles.title')}</Link></li>
        <li><Link to='/contact'>{t('contact.title')}</Link></li>
      </ul>

      <ul className='inline-list controls'>
        <li>
          <a href='https://twitter.com/ipacglobal'>
            <FontAwesomeIcon icon={faTwitter} />
            {' '}
            @ipacglobal
          </a>
        </li>
        {/*<li><LanguageSwitcher className='language-switcher' /></li>*/}
      </ul>
    </footer>
  )
}))`
  margin-top: ${rhythm(2)};
  padding: ${rhythm(1)} 0;
  ${media.tablet} { padding: ${rhythm(2)} 0 }
  text-align: center;
  border-top: 1px solid ${color.header};
  &.root {
    margin-top: 0;
    border: none;
  }

  .brand {
    margin: ${rhythm(1/2)} 0;

    span {
      display: block;
      margin: ${rhythm(1/4)} 0;
      font-size: 1rem;
    }
  }

  .links {
    margin-top: ${rhythm(1)};

    li {
      text-transform: lowercase;
      margin: 0 ${rhythm(1/2)};
    }
  }

  .language-switcher {
    margin: 0;
  }
`
